var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInflation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 49,
    viewBox: "0 0 51 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.60918 32.1467H14.3664V45H4.60914L4.60918 32.1467ZM11.6153 34.8133H7.36024V42.3333H11.6153V34.8133ZM32.6336 18.5823H42.3909V45H32.6336V18.5823ZM39.6397 21.249H35.3847V42.3334H39.6397V21.249ZM18.6214 25.3556H28.3786V45H18.6214V25.3556ZM25.6275 28.0223H21.3725V42.3333H25.6275V28.0223ZM44.5 45H2.5V42.3333H44.5L44.5 45ZM40.6301 14.8134H37.879V7.66679H30.506V5H40.63L40.6301 14.8134ZM6.02876 22.9378H5.9829V20.2712C17.274 20.2518 27.4934 15.8204 34.9073 8.66104L38.2825 5.39125L40.2267 7.2757L36.852 10.5468C32.9075 14.3842 28.204 17.4856 22.9779 19.6221L22.6931 19.7254C17.7822 21.7569 12.0687 22.9379 6.07063 22.9379C6.05596 22.9379 6.04121 22.9379 6.02654 22.9378H6.02876Z",
    fill: "#2A4887"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 49,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInflation);
export default __webpack_public_path__ + "static/media/inflation.ff7e679e7037dd5b8cb01e085a9d75e6.svg";
export { ForwardRef as ReactComponent };